// services/mapboxService.ts
// Note: Kept legacy filename to avoid sweeping import changes, but this now uses native Google Maps Geocoding.

export interface GeocodeResult {
    lat: number;
    lng: number;
    isExact: boolean;
    formattedAddress?: string;
}

export const geocode = async (query: string): Promise<GeocodeResult> => {
    if (!query || !query.trim()) throw new Error("Geocode query cannot be empty.");
    
    // Ensure Google Maps is loaded
    if (!window.google || !window.google.maps || !window.google.maps.Geocoder) {
        throw new Error("Google Maps API is not loaded yet.");
    }

    const geocoder = new window.google.maps.Geocoder();

    return new Promise((resolve, reject) => {
        geocoder.geocode({ address: query }, (results: any, status: any) => {
            if (status === 'OK' && results && results.length > 0) {
                const match = results[0];
                const locationType = match.geometry.location_type;
                
                // ROOFTOP or RANGE_INTERPOLATED usually mean an exact street address
                const isExact = (locationType === 'ROOFTOP' || locationType === 'RANGE_INTERPOLATED');
                
                resolve({
                    lat: match.geometry.location.lat(),
                    lng: match.geometry.location.lng(),
                    isExact: isExact,
                    formattedAddress: match.formatted_address
                });
            } else {
                reject(new Error(`Could not determine coordinates for "${query}". Google Maps Status: ${status}`));
            }
        });
    });
};
